import React from 'react';

const PlayButton = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.599695 24.0003C0.599695 11.0768 11.0762 0.600275 23.9997 0.600275C36.9232 0.600275 47.3997 11.0768 47.3997 24.0003C47.3997 36.9237 36.9232 47.4003 23.9997 47.4003C11.0762 47.4003 0.599695 36.9237 0.599695 24.0003Z"
        fill="black"
        fillOpacity="0.25"
        stroke="#D6DADC"
        strokeWidth="1.2"
      />
      <path
        d="M18.9148 16.6186C18.9148 15.5204 20.1216 14.8498 21.0542 15.4298L31.9785 22.2235C32.8594 22.7713 32.8594 24.0534 31.9785 24.6012L21.0542 31.395C20.1216 31.9749 18.9148 31.3043 18.9148 30.2061L18.9148 16.6186Z"
        fill="white"
        stroke="#D6DADC"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default PlayButton;
